import { OFFERS_API_URL } from './constants'
import { natAmount } from './nat-offers'
export interface NatTransferCandidate {
	id: string
	amount: string
}
export const TRANSFER_PAGE_SIZE = 10
/** Only the backend's live validated candidates are presented as selectable. */
export function transferCandidates(payload: unknown): NatTransferCandidate[] {
	if (
		!payload ||
		typeof payload !== 'object' ||
		!('candidates' in payload) ||
		!Array.isArray(payload.candidates) ||
		!('checked_tip' in payload) ||
		typeof payload.checked_tip !== 'string' ||
		!payload.checked_tip
	)
		throw new Error('Transfer validation unavailable')
	const seen = new Set<string>()
	return payload.candidates.map((row) => {
		if (
			!row ||
			typeof row.id !== 'string' ||
			!/^[a-f0-9]{64}i\d+$/.test(row.id) ||
			typeof row.amount !== 'string' ||
			!/^\d+$/.test(row.amount) ||
			!natAmount(row.amount) ||
			seen.has(row.id)
		)
			throw new Error('Invalid transfer inventory')
		seen.add(row.id)
		return { id: row.id, amount: row.amount }
	})
}
export async function readNatTransferPage(address: string, page: number) {
	const response = await fetch(
		`${OFFERS_API_URL}/market/offers/nat/transfers/${encodeURIComponent(address)}?offset=${
			page * TRANSFER_PAGE_SIZE
		}&t=${Date.now()}`,
		{ cache: 'no-store', signal: AbortSignal.timeout(30000) }
	)
	if (!response.ok) throw new Error('Could not verify NAT transfers. Try again.')
	const body = await response.json()
	const candidates = transferCandidates(body)
	if (
		typeof body.more !== 'boolean' ||
		!Number.isInteger(body.next_offset) ||
		body.next_offset < page * TRANSFER_PAGE_SIZE ||
		body.next_offset > (page + 1) * TRANSFER_PAGE_SIZE ||
		(body.more && body.next_offset !== (page + 1) * TRANSFER_PAGE_SIZE)
	)
		throw new Error('Invalid transfer page')
	return { candidates, more: body.more }
}
